const STORAGE_KEY = "seenNotificationIds";

const getSet = () => {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]"));
  } catch {
    return new Set();
  }
};

const saveSet = (set) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
};

export const seenNotificationIds = {
  has(id) {
    return getSet().has(id);
  },
  add(id) {
    const set = getSet();
    set.add(id);
    saveSet(set);
  },
};
